module.exports = __webpack_public_path__ + "img/bg_HAI.7037eea1.png";